<template>
  <div>
    <div class="w-full">
      <vx-card id="documentTypesCard" ref="documentTypes" title="Document Types" v-show="!isDocumentTypeListHidden">        
        <vs-table stripe ref="documentTypesTable" class="vs-con-loading__container" single @selected="handleSelectedDocumentType" pagination max-items="10" search :data="documentTypes"> <!-- v-scroll-to="'#documentTypeInfoCard'" -->
          <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
            <!-- ADD NEW -->
            <div ref="addNew" class="p-3 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewDocumentType">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add New</span>
            </div>
          </div>
          <template slot="thead">
            <vs-th sort-key="name">Name</vs-th>
            <vs-th sort-key="description">Description</vs-th>
            <vs-th sort-key="modifiedOn">Modified On</vs-th>
            <vs-th sort-key="modifiedBy">Modified By</vs-th>
            <vs-th></vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="documentType" :key="indextr" v-for="(documentType, indextr) in data" >

              <vs-td :data="data[indextr].name">
                {{ documentType.name }}
              </vs-td>

              <vs-td :data="data[indextr].description">
                {{ documentType.description }}
              </vs-td>

              <vs-td :data="data[indextr].modifiedOn">
                {{ documentType.modifiedOn.replace("T", " ").split('.')[0] }}
              </vs-td>

              <vs-td :data="data[indextr].modifiedBy">
                {{ documentType.modifiedBy }}
              </vs-td>

              <vs-td>
                <vs-chip v-show="documentType.isLinkedToModule" color="success">Linked To Module</vs-chip>
              </vs-td>

            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
    <div>
      <vx-card id="documentTypeInfoCard" ref="documentTypeInfo" title="Document Type Info" v-show="!isInfoHidden">
        <div class="vx-row mb-3">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label>Name</label>
            <vs-input autocomplete="off" onClick="this.select();" class="w-full" v-validate="'required|alpha_spaces'" name="Name" v-model="formData.name" />
            <span class="text-danger text-sm" v-show="errors.has('Name')">{{ errors.first('Name') }}</span>
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <label>Description</label>
            <vs-textarea class="w-full" v-model="formData.description" />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col">
            <vs-checkbox v-model="formData.isLinkedToModule">Link To Module</vs-checkbox>
          </div>
        </div>

        <vs-divider></vs-divider>
        
        <div class="vx-row">
          <vs-spacer></vs-spacer>
          <div class="vx-col">
            <vs-button color="success" class="mr-3 mb-2 vs-con-loading__container" @click.prevent="saveEditDocumentType" ref="saveEditButton">Save</vs-button>
            <vs-button color="danger" class="mr-4 vs-con-loading__container cursor-pointer" v-show="formData.id" @click="deleteDocumentType" ref="deleteButton">Delete</vs-button>
            <vs-button color="warning" type="border" class="mb-2" v-scroll-to="'#documentTypeInfoCard'" @click="cancelAdd">Cancel</vs-button>
          </div>
        </div>
      </vx-card>
    </div>
  </div>

</template>

<script>
export default {
  data() {
    return {
      loadingColor: "#fff",
      selected: [],
      isInfoHidden: true,
      isDocumentTypeListHidden: false,
      documentTypes: [],
      formData: {
        id: 0,
        name: "",
        description: "",
        isLinkedToModule: false
      },
      mode: "",
    };
  },
  methods: {
    initValues() {
      this.formData.id = 0;
      this.formData.name = "";
      this.formData.description = "";
      this.formData.isLinkedToModule = false;
      this.mode = "";
      this.errors.clear();
    },
    cancelAdd() {
      this.initValues();
      this.isInfoHidden = true;
      this.isDocumentTypeListHidden = false;
    },
    addNewDocumentType() {
      this.initValues();
      this.isDocumentTypeListHidden = true;
      this.isInfoHidden = false;
      this.mode = "Add Document Type";
    },
    saveData() {
      this.loadData();
      this.$vs.loading.close(this.$refs.saveEditButton.$el);
    },
    loadData() {
      const self = this;
      self.showLoadingOnElement("documentTypesTable", 1, "corners");

      var onSuccess = function(response) {
        self.documentTypes = response.data;
      };
      var onFinally = function() {
        self.$vs.loading.close(self.$refs.documentTypesTable.$el);
      };

      self.$ajaxGet(self, "documentType/listdocumentTypes", onSuccess, onFinally);
    },
    handleSelectedDocumentType(documentType) {
      this.mode = "Edit Document Type";
      this.formData.id = documentType.id;
      this.formData.name = documentType.name;
      this.formData.description = documentType.description;
      this.formData.isLinkedToModule = documentType.isLinkedToModule;
      this.isDocumentTypeListHidden = true;
      this.isInfoHidden = false;
    },
    saveEditDocumentType() {
      var self = this;
      self.$validator.validateAll().then(result => {
        if (result) {
          self.showLoadingOnElement("saveEditButton", 0.45, "material");

          var onSuccess = response => {
            self.saveData();
            self.isInfoHidden = true;
            self.scrollToNavbar();
            self.isDocumentTypeListHidden = false;
            self.$vs.notify({
              title: "Information",
              color: "success",
              text: "Document Type Saved",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-save"
            });
          };
          var onFinally = function() {
            self.$vs.loading.close(self.$refs.saveEditButton.$el);
          };

          self.$ajaxPost(self, "documentType/addeditdocumentType", self.formData, onSuccess, onFinally);
        } else {
          self.$vs.notify({
            title: "Attention",
            color: "warning",
            text: self.$validator.errors.items[0].msg,
            position: "top-right",
            iconPack: "feather",
            icon: "icon-info"
          });
        }
      });
    },
    deleteDocumentType() {
      var self = this;
      self.showLoadingOnElement("deleteButton", 0.45, "material");

      var onSuccess = response => {
        self.saveData();
        self.initValues();
        self.isDocumentTypeListHidden = false;
        self.isInfoHidden = true;
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: "Document Type Deleted",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-trash'
        });
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.deleteButton.$el);
      };

      self.$ajaxDelete(self, "documentType/" + self.formData.id, onSuccess, onFinally);
    },
    showLoadingOnElement(element, scale, type){
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    scrollToNavbar() {
      var scrollOptions = {
        easing: "ease-in",
        offset: -500,
        force: true,
        cancelable: true,
        x: false,
        y: true
      };
      var cancelScroll = this.$scrollTo(
        document.getElementById("navbarGlobal"),
        500,
        scrollOptions
      );
    }
  },
  mounted() {
    var self = this;
    self.loadData();
  }
};
</script>
